module.exports = __webpack_public_path__ + "img/other.67d72a04.png";